module.exports = __webpack_public_path__ + "static/img/041001.70b5ac95.png";